import { useCallback } from 'react'
import { useClerk } from '@clerk/react-router'
import { useNavigate } from 'react-router-dom'
import { useMainNavItems } from 'shared/hooks/useMainNavItems'
import { useFooterNavItems } from 'shared/hooks/useFooterNavItems'
import {
	clearCounselorLoginGrant,
	clearPendingCounselorGrant,
} from 'shared/auth/counselorLoginGrant'

export const useSidebar = () => {
	const { signOut } = useClerk()
	const navigate = useNavigate()
	const navItems = useMainNavItems()
	const footerNavItems = useFooterNavItems()

	const handleLogout = useCallback(
		e => {
			e?.preventDefault()
			clearCounselorLoginGrant()
			clearPendingCounselorGrant()
			signOut({ redirectUrl: '/auth' })
		},
		[signOut],
	)

	const openSettings = useCallback(() => {
		navigate('/settings')
	}, [navigate])

	return { navItems, footerNavItems, handleLogout, openSettings }
}
